(function () {
    'use strict';

    angular
        .module('ib-header-collapse-module')
        .controller('IbHeaderCollapseController', IbHeaderCollapseController);


    IbHeaderCollapseController.$inject = ['$rootScope', '$window', '$timeout'];
    function IbHeaderCollapseController($rootScope, $window, $timeout) {
        var vm = this;
        var closeCollapseHeaderEvent;
        vm.isCollapsed = false;
        vm.showDetails = false;
        vm.text = '';
        vm.closedText = 'HEADER_ADVANCED_SEARCH_PASSENGERS_CLOSED';
        vm.openedText = 'HEADER_ADVANCED_SEARCH_PASSENGERS_OPENED';
        vm.clickCollapse = clickCollapse;
        vm.clickDetails = clickDetails;
        vm.toggle = toggle;
        vm.externalChangeText = externalChangeText;
        vm.initCollapse = initCollapse;
        vm.closeCollapse = closeCollapse;
        vm.init = true;
        vm.isMobile = mobileView();
        vm.basketOpen = false;

        closeCollapseHeaderEvent = $rootScope.$on('closeCollapseHeader', closeCollapse);
    
        /**
         * Close collapse 
         * @param {*} evt 
         */
        function closeCollapse(evt) {
            vm.isCollapsed = false;
            if($window.innerWidth < 768 && !vm.isCollapsed) {
                angular.element('body').removeClass('ib-collapse--open');
            }
        }


        function clickCollapse(e, prevent) {
            var clickedElement, clickedParent;
            vm.isCollapsed = !vm.isCollapsed;
            clickedElement = e.target;
            clickedParent = clickedElement.closest('.ib-basket--trigger');
            if (clickedParent === null) {
                $timeout(function () {
                    vm.basketOpen = !vm.basketOpen;
                });
            }
            if ($window.innerWidth < 768) {
                angular.element('body').addClass('ib-collapse--open');
            } else {
                angular.element('body').removeClass('ib-collapse--open');
            }
            if (prevent || angular.isUndefined(prevent)) {
                e.preventDefault();
            }
        }

        function clickDetails(e, prevent) {
            vm.showDetails = !vm.showDetails;
            if (prevent || angular.isUndefined(prevent)) {
                e.preventDefault();
            }
        }

        function initCollapse(closedText, openedText) {
            vm.closedText = closedText;
            vm.text = closedText;
            vm.openedText = openedText;
            // vm.isCollapsed = false;
        }

        function externalChangeText(text) {
            vm.text = !vm.isCollapsed ? text : vm.text;
            vm.closedText = text;
        }

        function toggle() {
            vm.isCollapsed = !vm.isCollapsed;
            vm.text = vm.isCollapsed ? vm.openedText : vm.closedText;
            vm.init = false;
            vm.basketOpen = !vm.basketOpen;
            collapseControl();
        }
        function mobileView(){
            var isMobile = false;
            if ($window.innerWidth < 768) {
                isMobile = true;
            } else {
                isMobile = false;
            }
            return isMobile;
        }
        function collapseControl() {
            var body = angular.element('body');
            if(vm.isMobile && !vm.isCollapsed){
                body.removeClass('ib-collapse--open');
            }else if(vm.isMobile && vm.isCollapsed){
                body.addClass('ib-collapse--open');
            }else if(!vm.isMobile && vm.isCollapsed){
                body.removeClass('ib-collapse--open');
            }
        }
        angular.element($window).on('resize', function () {
            vm.isMobile = mobileView();
            if (vm.basketOpen) {
                collapseControl();                
            }
        });
    }
})();